import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import type { DocumentType, ReferenceDocumentTypeFieldProps } from '@/types';

interface ManifestReferenceDocumentTypeFieldProps
  extends ReferenceDocumentTypeFieldProps<DocumentType> {}

function ManifestReferenceDocumentTypeField({
  options,
  value,
  setValue,
  edit,
}: ManifestReferenceDocumentTypeFieldProps): React.JSX.Element {
  const [selected, setSelected] = useState<DocumentType | null>(value);

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: DocumentType | null,
  ): void => {
    setSelected(newValue);
    setValue(newValue);
  };

  return (
    <Box>
      <Autocomplete
        id='governing-document-types-field'
        options={options}
        value={selected || undefined}
        sx={{ width: '100%' }}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        disableClearable={true}
        disabled={edit}
        renderInput={(params) => (
          <TextField {...params} label='Governing Document Type' />
        )}
      />
    </Box>
  );
}
export default ManifestReferenceDocumentTypeField;
